import styled from "styled-components";

export const GroupRow = styled.div`
  background-color: transparent;
  border-bottom: 4px solid var(--surface-d);
  margin-top: 10px;
  cursor: pointer;
`;
